import React from 'react';
import { FC } from 'react';

export const PathYielder: FC = () => {
    return (
        <div>
            <div> 
                <iframe 
                title="Slide" 
                src="https://docs.google.com/presentation/d/e/2PACX-1vQUMagtiEOJS_6Kzizin3UDK4rdOrX9w_CaYXW9nQxlnMP_l1f-U6iVEI6ytx2dwvdS5KFTw6600hkd/embed?start=false&loop=false&delayms=3000"
                width="1200" height="675">
                </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};